import {
	BreakpointWrapper,
	Breakpoints,
	CTA,
	Container,
	ContainerGutter,
	ContainerPadding,
	Layout,
	Text,
	TextAlignment,
	TextTag,
	TokenTextAppearance,
	TokenTextColor,
	styled,
} from '@volkswagen-onehub/components-core';
import { MotionValue } from 'framer-motion';
import React, { useContext } from 'react';
import { PortalContext } from '../../../context/portal-context';
import { Environment } from '../../../enviroment';
import { formatOwnership } from '../../../tracking/tracking-helper';
import { useTrackingManager } from '../../../tracking/use-tracking-manager';
import { VipsGaleria } from './vips-galeria';

const VipsContentWrapper = styled.div`
	height: 100%;
	display: flex;
	align-items: center;
`;

const PrettyText = styled(Text)`
	text-wrap: pretty;
`;

export const VipsContent = ({ progress }: { progress: MotionValue<number> }): React.ReactElement => {
	const trackingManager = useTrackingManager();
	const { portalService, navigationService } = useContext(PortalContext);
	const userVehicles = portalService.getPersonVehicles().getValue();

	const environmentPath = Environment.getInstance().vips;
	const target = navigationService.navigateTo(environmentPath, {});

	const handleTrackingOnClick = () => {
		trackingManager.trackClubVWButtonClick(
			'Conoce toda su historia - VIPS - Open Historias Volkswagen',
			{ contentId: 'Conoce toda su historia - VIPS - Open Historias Volkswagen' },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
		if (target) {
			target.push();
		} else {
			console.log('Page with id non exsistent');
		}
	};

	return (
		<Container data-testid="vips-content__container">
			<Layout
				data-testid="vips-content__layout"
				appearance={{
					[Breakpoints.default]: [
						{ name: '.', columns: 1 },
						{ name: 'vips-left-content', columns: 22 },
						{ name: '.', columns: 1 },
						{ name: '.', columns: 0 },
						{ name: 'vips-gallery', columns: 24 },
						{ name: '.', columns: 0 },
					],
					[Breakpoints.b960]: [
						{ name: '.', columns: 1 },
						{ name: 'vips-left-content', columns: 9 },
						{ name: '.', columns: 1 },
						{ name: 'vips-gallery', columns: 12 },
						{ name: '.', columns: 1 },
					],
				}}
				allowOverflowingContent
			>
				<VipsContentWrapper>
					<Container
						wrap={'always'}
						gutter={ContainerGutter.static400}
						padding={{
							top: {
								[Breakpoints.default]: ContainerPadding.dynamic0250,
								[Breakpoints.b1280]: ContainerPadding.dynamic0300,
							},
							bottom: {
								[Breakpoints.default]: ContainerPadding.dynamic0250,
								[Breakpoints.b1280]: ContainerPadding.dynamic0300,
							},
						}}
						data-testid="vips-left-content"
					>
						<Container wrap={'always'} gutter={ContainerGutter.static400}>
							<PrettyText
								tag={TextTag.h2}
								appearance={TokenTextAppearance.headline500}
								color={TokenTextColor.primary}
								textAlign={TextAlignment.left}
								bold
							>
								Arántzazu. La pasión de su vida
							</PrettyText>

							<PrettyText
								tag={TextTag.span}
								appearance={TokenTextAppearance.bigcopy100}
								color={TokenTextColor.primary}
								textAlign={TextAlignment.left}
							>
								¿Se puede estar enamorada de un coche? Cuando su padre compró un Golf GTI MK2 rojo, lo de Arántzazu fue
								amor a primera vista. Y, desde entonces, todo cambió...
							</PrettyText>

							<PrettyText
								tag={TextTag.span}
								appearance={TokenTextAppearance.bigcopy100}
								color={TokenTextColor.primary}
								textAlign={TextAlignment.left}
								bold
							>
								Si te gustan las historias de amor, dale al play y descubre la suya.
							</PrettyText>
						</Container>

						<CTA tag="a" emphasis="primary" onClick={handleTrackingOnClick} target="_blank">
							<Text>Conoce toda su historia</Text>
						</CTA>
					</Container>
				</VipsContentWrapper>

				<Container data-testid="vips-gallery">
					<BreakpointWrapper max={Breakpoints.b560}>
						<VipsGaleria progress={progress} rows={2} horizontal />
					</BreakpointWrapper>
					<BreakpointWrapper min={Breakpoints.b560} max={Breakpoints.b960}>
						<VipsGaleria progress={progress} rows={1} horizontal />
					</BreakpointWrapper>
					<BreakpointWrapper min={Breakpoints.b960}>
						<VipsGaleria progress={progress} rows={3} />
					</BreakpointWrapper>
				</Container>
			</Layout>
		</Container>
	);
};
